
import React, { useState, useEffect } from "react";

import CButton from "../../../basecomp/components/CButton";
import CDateTimePicker from "../../../basecomp/components/CDateTimePicker";
import CMainGrid from "../../../basecomp/components/wrapper/CMainGrid";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import DownloadIcon from "@mui/icons-material/Download";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import MCTDashboardVM from "../viewmodel/MCTDashboardVM";
import MaterialCreationLoader from "./MaterialCreationLoader";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";

const buttonStyle = {
  "& > span > button": {
    background: "linear-gradient(135deg, #042560 0%, #042560 100%) !important",
    color: "#ffffff !important",
    borderRadius: "10px !important",
    fontWeight: "700 !important",
    textTransform: "none !important",
    boxShadow: "0 8px 20px rgba(4, 37, 96, 0.25) !important",
    transition: "all 0.2s ease !important",
    "&:hover": {
      transform: "translateY(-2px) !important",
      boxShadow: "0 12px 24px rgba(4, 37, 96, 0.35) !important",
    },
  },
};
const MCTDashboardView = () => {
  const {
    handleStartDateChange,
    handleEndDateChange,
    handleDownload,
    loading,
    error,
  } = MCTDashboardVM();

  useEffect(() => {
    const fontId = "lato-font-link";
    if (!document.getElementById(fontId)) {
      const link = document.createElement("link");
      link.id = fontId;
      link.href =
        "https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&display=swap";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
  }, []);

  const outerTheme = useTheme();
  const localTheme = createTheme(outerTheme, {
    typography: {
      ...outerTheme.typography,
      fontFamily: "Lato, sans-serif",
    },
  });

  return (
    <ThemeProvider theme={localTheme}>
      <>
        <MaterialCreationLoader
          open={loading}
          variant="download"
          title="Preparing dashboard export"
          message="Collecting material dashboard data for your selected date range."
        />
        <CMainGrid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          sx={{ margin: "6em 0.75em 1em" }}
        >
          <Paper
            elevation={0}
            sx={{
              borderRadius: "8px",
              border: "1px solid #dbe3ef",
              overflow: "hidden",
              boxShadow: "0 18px 45px rgba(15, 23, 42, 0.08)",
              background: "#ffffff",
            }}
          >
            <Box sx={{ p: { xs: 2, md: 3 } }}>
              <CMainGrid
                container
                spacing={2}
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CMainGrid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "4px",
                      fontWeight: 600,
                    }}
                  >
                    Start Date 
                  </label>
                  <CDateTimePicker
                    // cHelperText="Start Date"
                    cOnChange={handleStartDateChange}
                    cFullWidth={true}
                  />
                </CMainGrid>
                <CMainGrid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "4px",
                      fontWeight: 600,
                    }}
                  >
                    End Date 
                  </label>
                  <CDateTimePicker
                    // cHelperText="End Date"
                    cOnChange={handleEndDateChange}
                    cFullWidth={true}
                  />
                </CMainGrid>
              </CMainGrid>

              {error && (
                <CMainGrid
                  container
                  sx={{
                    marginTop: "1em",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CMainGrid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Alert severity="error" sx={{ borderRadius: "8px" }}>
                      {error}
                    </Alert>
                  </CMainGrid>
                </CMainGrid>
              )}

              <CMainGrid
                container
                sx={{
                  marginTop: "1em",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CMainGrid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box sx={{ ...buttonStyle, width: "220px" }}>
                      <CButton
                        cId="mct_btn_download_dashboard"
                        cText={
                          loading ? "Downloading..." : "Download Dashboard"
                        }
                        cOnClick={handleDownload}
                        cDisabled={loading}
                      />
                    </Box>
                  </Box>
                </CMainGrid>
              </CMainGrid>
            </Box>
          </Paper>
        </CMainGrid>
      </>
    </ThemeProvider>
  );
};

export default MCTDashboardView;
